var LockType;
(function (LockType) {
    LockType["Subflow"] = "subflow";
})(LockType || (LockType = {}));
export class LockService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    async send(command, flowId, additionalUri = '') {
        return await this.MessagingHubService.sendCommand({
            method: command,
            to: 'postmaster@builder.msging.net',
            type: 'application/json',
            uri: `/locks/${LockType.Subflow}/id/${flowId}${additionalUri}`, // For now, this is used only for subflow. It's expected to be used for regular bots in the future.
            resource: {},
        });
    }
    async get(flowId) {
        return await this.send('get', flowId);
    }
    formatNode(node) {
        return `/node/${encodeURIComponent(node)}`;
    }
    async set(flowId, localNode) {
        return await this.send('set', flowId, this.formatNode(localNode));
    }
    async delete(flowId, localNode) {
        return await this.send('delete', flowId, this.formatNode(localNode));
    }
}
LockService.$inject = ['MessagingHubService'];
